import { useQuery } from '@mint-lib/query-client';
import { useFlags } from '@mint-lib/routing-context';
import { MediaPlan } from '@mint-sdk/api-media-plan';
import { getRouteApi } from '@mint/routing';

import { useChosenLevel } from '../../hooks/useChosenLevel.js';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useColumnsApi = ({ enabled = true } = {}) => {
  const ff = useFlags('@mint/arm', ['planningV2ColumnsPerView']);
  const perView = ff.planningV2ColumnsPerView.enabled;
  const { campaignId: planId } = routerApi.useParams();
  const { id, level } = useChosenLevel();

  const queryOptions = (
    perView
      ? MediaPlan.getColumnsListByViewQueryOptions({
          urlParams: { planId },
          params: { view: level as MediaPlan.PlanningGridViewType },
        })
      : MediaPlan.getColumnsListQueryOptions({
          params: { mediaDataId: id ?? '' },
        })
  ) as ReturnType<typeof MediaPlan.getColumnsListQueryOptions>;

  const { data, ...rest } = useQuery({
    ...queryOptions,
    enabled: enabled && (perView ? !!planId : !!id),
    staleTime: Infinity, // default refetch is not needed, we refetch on socket event
  });
  return { data: data?.data, ...rest };
};
